'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:train:selectTrains');
}

var _invoke = require('../invoke');

/**
 *
 * @memberof train
 * @static
 * @name selectTrains
 * @param {Array} menus 菜单
 * @return {Promise}
 * @example
 *  hbnb.train.selectTrains([{
 *      label: '',
 *      subLabel: '',
 *      description: ''
 *      value: '',
 *      active: false
 *  }])
 *      .then(function(menus) {
 *          menus = [{
 *              label: '',
 *              value: '',
 *              active: false
 *          }]
 *      });
 */
module.exports = function(menus) {
    if (process.env.NODE_ENV !== 'production') {
        debug('menus is %j', menus);
    }

    var p = new Promise(function(resolve, reject) {
        _invoke('train', 'select_trains', {
            menus: menus,
            callback: function(menus) {
                resolve(menus);
            }
        });
    });

    return p;
};



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@hfe/hbnb/train/select-trains.js
// module id = 637
// module chunks = 0